module.exports = __webpack_public_path__ + "img/767-700a3c.png";